import { Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { FormGroup, FormControl } from '@angular/forms';
import {ApiService} from "../api.service";
import {EmailRegisteredValidator} from "./emailRegistered.validator";


@Component({
  selector: 'platform-register-form',
  templateUrl: './register-form.component.html',
  providers: [ApiService]
})
export class RegisterFormComponent implements OnInit {
    registerForm = new FormGroup({
        email: new FormControl('', {validators: [Validators.required, Validators.email], asyncValidators: [this.emailRegisteredValidator.validate],  updateOn: 'blur'}),
        password: new FormControl('', [Validators.required, Validators.minLength(4)]),
        newsletter: new FormControl(false),
        toc: new FormControl(false, Validators.requiredTrue)
    });


    constructor(private apiService: ApiService, private emailRegisteredValidator: EmailRegisteredValidator) { }

  ngOnInit() {
  }
  onSubmit() {
      console.log("Register clicked");
      console.log(this.registerForm.status);
      console.log(this.registerForm.value);
      if(!this.registerForm.valid) {
          console.log("stop form invalid");
          return;
      };
      console.log(this.apiService.registerEmail(this.registerForm.value.email, this.registerForm.value.password, this.registerForm.value.newsletter).subscribe(resp => {console.log(resp);}));
  }

}
